import ToastHighLighter from '@/lib/ToastHighLighter';

export const BasicHTMLPageCode = () => {
  const language = 'html';
  const codeString = `
// Example code - basic template
  <!doctype html>
  <html lang="de" dir="ltr">
    <head>
      ...
      <meta charset="utf-8">
      <meta name="viewport" content="width=device-width, initial-scale=1">
      <title>FHNW Bootstrap-Styleguide Demo</title>
      <link rel="stylesheet" href="./css/fhnw.min.css">
      ...
    </head>
    <body>
      ...
      <script src="https://cdn.jsdelivr.net/npm/bootstrap@5.3.2/dist/js/bootstrap.bundle.min.js" integrity="sha384-C6RzsynM9kWDrMNeT87bh95OGNyZPhcTNXj1NW7RuBCsyN/o0jlpcV8Qyq46cDfL" crossorigin="anonymous"></script>
      <script type="text/javascript" src="./js/cookieconsent.js"></script>
      <script type="text/javascript" src="./js/default.js"></script>
    </body>
  </html>
`;

  return (
    <>
      <ToastHighLighter
        name={'exampleCode'}
        codeString={codeString}
        language={language}
        show={true}
      />
    </>
  );
};

export const HeadStylesheetCode = () => {
  const language = 'html';
  const codeString = `
  <head>
    ...
    <link rel="stylesheet" href="./css/fhnw.min.css">
    ...
  </head>
`;

  return (
    <>
      <ToastHighLighter
        name={'headStylesheet'}
        codeString={codeString}
        language={language}
        show={true}
        disableCopy={true}
      />
    </>
  );
};

export const DefaultJSExampleCode = () => {
  const language = 'javascript';
  const codeString = `
    ...
    // EXCERPT default.js

    // BACK-TO-TOP
    var back_to_top_button = '<a href="#top" title="Back-To-Top" class="back-to-top"></a>';
    document.querySelector('body').insertAdjacentHTML('beforeend', back_to_top_button);

    window.addEventListener('scroll', function () {
      if (window.pageYOffset > 100) {
        document.querySelector('.back-to-top').style.opacity = 0.4;
      } else {
        document.querySelector('.back-to-top').style.opacity = 0;
      }
    });
    
    ...

    // SELECT2 - DEFAULTS
    $('select').select2({
      theme: 'bootstrap-5',
      placeholder: 'Choose an option',
      closeOnSelect: true,
      allowClear: true,
      width: $(this).data('width') ? $(this).data('width') : $(this).hasClass('w-100') ? '100%' : 'style',
    });

    ...
`;

  return (
    <>
      <ToastHighLighter
        name={'defaultJavascript'}
        codeString={codeString}
        language={language}
        show={true}
        disableCopy={true}
      />
    </>
  );
};

export const FaviconsCode = () => {
  const language = 'html';
  const codeString = `
  // Favicons
  ...
  <head>
  ...
  <link href="./assets/img/device/apple-icon-57x57.png" rel="apple-touch-icon" sizes="57x57" />
  <link href="./assets/img/device/apple-icon-60x60.png" rel="apple-touch-icon" sizes="60x60" />
  <link href="./assets/img/device/apple-icon-72x72.png" rel="apple-touch-icon" sizes="72x72" />
  <link href="./assets/img/device/apple-icon-76x76.png" rel="apple-touch-icon" sizes="76x76" />
  <link href="./assets/img/device/apple-icon-114x114.png" rel="apple-touch-icon" sizes="114x114" />
  <link href="./assets/img/device/apple-icon-120x120.png" rel="apple-touch-icon" sizes="120x120" />
  <link href="./assets/img/device/apple-icon-144x144.png" rel="apple-touch-icon" sizes="144x144" />
  <link href="./assets/img/device/apple-icon-152x152.png" rel="apple-touch-icon" sizes="152x152" />
  <link href="./assets/img/device/apple-icon-180x180.png" rel="apple-touch-icon" sizes="180x180" />
  <link href="./assets/img/device/android-icon-192x192.png" rel="icon" sizes="192x192" type="image/png" />
  <link href="./assets/img/device/favicon-32x32.png" rel="icon" sizes="32x32" type="image/png" />
  <link href="./assets/img/device/favicon-96x96.png" rel="icon" sizes="96x96" type="image/png" />
  <link href="./assets/img/device/favicon-16x16.png" rel="icon" sizes="16x16" type="image/png" />
  ...
  </head>
`;

  return (
    <>
      <ToastHighLighter
        name={'favicons'}
        codeString={codeString}
        language={language}
        show={true}
      />
    </>
  );
};

export const CookieConsentCode = () => {
  const language = 'javascript';
  const codeString = `
  // Cookie-Consent excerpt
  ...
  
  var cDomain = '.fhnw.ch'; // change this to your domain, if your page is not a fhnw.ch subdomain

  ...
`;

  return (
    <>
      <ToastHighLighter
        name={'cookieconsent'}
        codeString={codeString}
        language={language}
        show={true}
        disableCopy={true}
      />
    </>
  );
};
